import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase";
import { v4 as uuidv4 } from "uuid";
import "./admin.css";

interface Office {
  id: string;
  name: string;
  address: string;
  email: string;
  phone: string;
  fax?: string;
}

export const AdminContactPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [offices, setOffices] = useState<Office[]>([]);
  const [newOffice, setNewOffice] = useState<Partial<Office>>({});

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "contact_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setOffices(data.offices || []);
      }
    };
    fetchData();
  }, []);

  const handleBannerUpload = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `contact/banner_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);
    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const addOffice = () => {
    const { name, address, email, phone, fax } = newOffice;
  
    if (!name || !address || !email || !phone) {
      alert("Completează toate câmpurile obligatorii.");
      return;
    }
  
    const newEntry: Office = {
      id: uuidv4(),
      name,
      address,
      email,
      phone,
      fax: fax || "",
    };
  
    setOffices((prev) => [...prev, newEntry]);
    setNewOffice({});
  };
  

  const deleteOffice = (id: string) => {
    setOffices((prev) => prev.filter((o) => o.id !== id));
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "contact_page"), {
      header_image: headerImage,
      offices,
    });
    alert("Salvat cu succes!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Pagina Contact</h1>

      <label>Imagine banner:</label>
      <input type="file" accept="image/*" onChange={(e) => setHeaderFile(e.target.files?.[0] || null)} />
      <button onClick={handleBannerUpload}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <hr />

      <h2>Sedii existente</h2>
      {offices.map((office) => (
        <div key={office.id} className="office-item">
          <strong>{office.name}</strong>
          <p>{office.address}</p>
          <p>{office.email}</p>
          <p>{office.phone}</p>
          {office.fax && <p>{office.fax}</p>}
          <button onClick={() => deleteOffice(office.id)}>Șterge</button>
        </div>
      ))}

      <hr />

      <h2>Adaugă sediu nou</h2>
      <input
        type="text"
        placeholder="Nume sediu"
        value={newOffice.name || ""}
        onChange={(e) => setNewOffice({ ...newOffice, name: e.target.value })}
      />
      <input
        type="text"
        placeholder="Adresă"
        value={newOffice.address || ""}
        onChange={(e) => setNewOffice({ ...newOffice, address: e.target.value })}
      />
      <input
        type="email"
        placeholder="Email"
        value={newOffice.email || ""}
        onChange={(e) => setNewOffice({ ...newOffice, email: e.target.value })}
      />
      <input
        type="text"
        placeholder="Telefon"
        value={newOffice.phone || ""}
        onChange={(e) => setNewOffice({ ...newOffice, phone: e.target.value })}
      />
      <input
        type="text"
        placeholder="Fax (opțional)"
        value={newOffice.fax || ""}
        onChange={(e) => setNewOffice({ ...newOffice, fax: e.target.value })}
      />
      <button onClick={addOffice}>Adaugă</button>

      <hr />
      <button className="save-btn" onClick={saveAll}>Salvează tot</button>
    </div>
  );
};
